define('setup/default-numbers/default-numbers',['require','jquery','durandal/app','knockout','../setup-configurator','api-access','api-access','lib/audio/audio-default-countries','mode-generator','../../settings/lib/country-selector/country-selector','country-text'],function (require) {
    var $ = require('jquery');
    var app = require('durandal/app');
    var ko = require('knockout');
    var setupConfigurator = require('../setup-configurator');
    var userApi = require('api-access').user;
    var commerceApi = require('api-access').commerce;
    var audioDefaultCountries = require('lib/audio/audio-default-countries');
    var modeGenerator = require('mode-generator');
    var CountrySelector = require('../../settings/lib/country-selector/country-selector');
    var countryText = require('country-text');

    return function () {
        var self = this;
        var setupConfig;

        self.isModalOpen = ko.observable(false);
        self.usersSettings = ko.observable();
        self.allowedModes = ko.observable();
        self.defaultTollCountries = ko.observableArray();
        self.preferredTollCountry = ko.observable();
        self.defaultTollFreeCountries = ko.observableArray();
        self.preferredTollFreeCountry = ko.observable();
        self.backEnabled = ko.observable();

        // build allowedModes and defaultModes
        self.modes = ko.computed(function () {
            if (self.usersSettings()) {
                var modes = modeGenerator(self.usersSettings());

                self.allowedModes(modes.allowed);
            }
        });

        self.countryText = countryText;

        self.showCountrySelector = function (title, tollFree) {
            if (self.usersSettings() && !self.isModalOpen()) {
                self.isModalOpen(true);
                var selector = new CountrySelector(title, tollFree);
                selector.show()
                  .then(function () {
                      self.isModalOpen(false);
                  })
                  .fail(function () {
                      self.isModalOpen(false);
                  });
            }
        };

        self.getCountries = function () {
            var countriesPromise = $.Deferred();

            $.when(userApi.settings(), userApi.me())
                .then(function (userSettingsResponse) {
                    var userSettings = userSettingsResponse[0];

                    self.usersSettings(userSettings);
                    self.preferredTollCountry(userSettings.audio.preferredTollCountry);
                    self.preferredTollFreeCountry(userSettings.audio.preferredTollFreeCountry);

                    var billingCountry;
                    commerceApi.getBilling()
                        .then(function (billing) {
                            billingCountry = billing.country;
                        })
                        .always(function () {
                            self.defaultTollCountries(
                                audioDefaultCountries(
                                    userSettings.audio.defaultTollCountries,
                                    userSettings.audio.allowedTollCountries,
                                    billingCountry
                                )
                            );

                            self.defaultTollFreeCountries(
                                audioDefaultCountries(
                                    userSettings.audio.defaultTollFreeCountries,
                                    userSettings.audio.allowedTollFreeCountries,
                                    billingCountry
                                )
                            );

                            countriesPromise.resolve();
                        });
                });

            return countriesPromise;
        };

        self.back = function () {
            window.location.href = setupConfig['default-numbers'].backUrl;
        };

        self.done = function () {
            window.location.href = setupConfig['default-numbers'].nextUrl;
        };

        self.activate = function () {
            return $.when(
                self.getCountries(),
                setupConfigurator.update()
            ).then(function () {
                setupConfig = setupConfigurator.getSetupData();

                self.backEnabled(setupConfig['default-numbers'].backUrl);

                userApi.updateSettings({organizerAudioOnboardingViewed: true});
            });
        };

        // event to pull countries only
        app.on('get:country-settings', function () {
            self.getCountries();
        });
    };
});

